export default function TicketIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M15.4008 4.80078V7.02935M15.4008 11.4865V13.7151M15.4008 18.1722V20.4008M4.06745 4.80078L19.9341 4.80078C20.5353 4.80078 21.1118 5.03558 21.5369 5.45351C21.962 5.87145 22.2008 6.4383 22.2008 7.02935V10.3722C21.5996 10.3722 21.0231 10.607 20.598 11.0249C20.1729 11.4429 19.9341 12.0097 19.9341 12.6008C19.9341 13.1918 20.1729 13.7587 20.598 14.1766C21.0231 14.5946 21.5996 14.8294 22.2008 14.8294V18.1722C22.2008 18.7633 21.962 19.3301 21.5369 19.748C21.1118 20.166 20.5353 20.4008 19.9341 20.4008H4.06745C3.46629 20.4008 2.88975 20.166 2.46467 19.748C2.03959 19.3301 1.80078 18.7633 1.80078 18.1722V14.8294C2.40194 14.8294 2.97847 14.5946 3.40356 14.1766C3.82864 13.7587 4.06745 13.1918 4.06745 12.6008C4.06745 12.0097 3.82864 11.4429 3.40356 11.0249C2.97847 10.607 2.40194 10.3722 1.80078 10.3722V7.02935C1.80078 6.4383 2.03959 5.87145 2.46467 5.45351C2.88975 5.03558 3.46629 4.80078 4.06745 4.80078Z"
        stroke="currentColor"
        stroke-width="1.44"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
